<script module lang="ts">
  import { page } from "$app/state";

  import type { Product } from "@agapi/mlc-core";
  import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@agapi/ui/accordion";
  import { Markdown, styledMarkdownOverride } from "../../../components";
  import { getLocaleFromUrl, getLocaleFormattedAmount } from "../../../utils";

  import * as m from '$lib/parachute/messages';
  export interface ProductInfoAccordionProps {
    product: Product;
    last30DaySales?: number;
  }
</script>

<script lang="ts">
  const { product, last30DaySales }: ProductInfoAccordionProps = $props();
</script>

{#key product}
  <Accordion value={[m.description()]} multiple={true}>
    <AccordionItem title={m.description()}>
      <AccordionTrigger />
      <AccordionContent>
        <Markdown value={product.description.long} css={styledMarkdownOverride} />
      </AccordionContent>
    </AccordionItem>

    {#if product.ingredients}
      <AccordionItem title={m.ingredients()}>
        <AccordionTrigger />
        <AccordionContent>
          <Markdown value={product.ingredients} css={styledMarkdownOverride} />
        </AccordionContent>
      </AccordionItem>
    {/if}

    {#if product.nutrition}
      <AccordionItem title={m.nutrition()}>
        <AccordionTrigger />
        <AccordionContent>
          <Markdown value={product.nutrition} css={styledMarkdownOverride} />
        </AccordionContent>
      </AccordionItem>
    {/if}

    <AccordionItem title={m.priceHistory()}>
      <AccordionTrigger />
      <AccordionContent>
        {m.lowestPriceLast30Days({ price: getLocaleFormattedAmount(last30DaySales ?? product.variants[0].price.amount, getLocaleFromUrl(page.url)) })}
      </AccordionContent>
    </AccordionItem>
  </Accordion>
{/key}
